/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AddRoundToTabRequest} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'
import {AddRoundToTabResponse} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'


export const addRoundToTab = (request: AddRoundToTabRequest, options?: CashRequestOptions) => post<AddRoundToTabRequest, AddRoundToTabResponse>("/cash-app/local/cart/add-round", request, {...options, rejectOnError: true })